<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div v-if="product" class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4>Añadir tarifa</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label class="control-label">Ref.</label>
								<input
									v-model="item.ref"
									type="text"
									class="form-control">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group" :class="{ 'has-error' : errors.has('Price') }">
								<label class="control-label">Precio</label>
								<input
									v-validate="'required'"
									v-model="item.price"
									type="number"
									name="Price"
									class="form-control">
									<small v-show="errors.has('Price')" class="form-text text-danger">
										{{ errors.first('Price') }}
									</small>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label class="control-label">Descuento</label>
								<input
									:disabled="!item.price"
									v-model="item.discount"
									type="number"
									class="form-control">
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label class="control-label">Ahorro</label>
								<input
									readonly
									v-model="item.save"
									type="number"
									class="form-control">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group" :class="{ 'has-error' : errors.has('Total') }">
								<label class="control-label">Total</label>
								<input
									v-validate="'required'"
									v-model="item.total"
									type="number"
									name="Total"
									class="form-control">
									<small v-show="errors.has('Total')" class="form-text text-danger">
										{{ errors.first('Total') }}
									</small>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button ref="btnStore" @click="validate()" type="button" class="btn btn-success">Guardar</button>
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Treeselect from '@riophae/vue-treeselect'

	export default {
		props: ['user', 'isAuth', 'product'],
		components: {
			'treeselect': Treeselect,
		},
		data () {
			return {
				modal: {
					selector: 'modal-product-price-list-create',
				},

				item: {
					ref: null,
					price: null,
					discount: null,
					total: null,
					product_id: this.product.id,
				},
			}
		},
		watch: {
			'item.price'() {
				if(!this.item.price) {
					this.item.discount = null;
				}
				this.item.price = this.$options.filters.checkDecimals(this.item.price)
				this.calculateTotal()
				this.calculateSave()
			},
			'item.discount'() {
				this.item.discount = this.$options.filters.checkDecimals(this.item.discount)
				if(this.item.discount > 100) {
					this.item.discount = 100
				}
				this.calculateSave()
				this.calculateTotal()
			},
		},
		methods: {
			open() {
				var that = this
				var modal = $('#'+this.modal.selector)
				modal.modal('show')

				$('#'+this.modal.selector).on("hidden.bs.modal", function() {
					that.clearData()
					that.$validator.reset()
				})
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.item.ref = null
				this.item.price = null
				this.item.discount = null
				this.item.save = null
				this.item.total = null
				this.item.product_id = this.product.id
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store: function() {
				var loading = Ladda.create(this.$refs.btnStore)
				loading.start()
				this.$http.post('admin/management/products/price/lists', this.item)
					.then(response => {
						this.$emit('reload')
						loading.stop()
						this.close()
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}).catch(function(response) {
						loading.stop()
						console.log(response)
					})
			},

			//--
			calculateSave() {
				var save = 0
				if(this.item.price) {
					var price = this.item.price
				} else {
					var price = 0
				}

				if(this.item.discount) {
					var discount = this.item.discount
				} else {
					var discount = 0
				}

				save = discount / 100 * price
				this.item.save = parseFloat(save).toFixed(2)
			},
			calculateTotal() {
				var total = 0
				if(this.item.price) {
					var price = this.item.price
				} else {
					var price = 0
				}

				if(this.item.discount) {
					var discount = this.item.discount
				} else {
					var discount = 0
				}

				total = price - (discount / 100 * price)
				this.item.total = parseFloat(total).toFixed(2)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/products/components/priceList/views/Create.vue